import { Injectable, OnInit, Injector } from '@angular/core';
import { HttpService } from 'app/resources/services/http.service';
import { CartaoService } from 'app/resources/services/cartao.service';

type Saldo = {
  id: number,
  saldoPontos: number,
  saldoPontosDevedor: number,
  uuid: string
};

@Injectable()
export class SaldoService {

  public saldo: Saldo = {
    id: undefined,
    saldoPontos: undefined,
    saldoPontosDevedor: undefined,
    uuid: undefined
  };

  constructor(
    public http: HttpService,
    public cartaoService: CartaoService
  ) { }

  public initialize() {
    this.http.pathV2().get('auth/users/cartoes/current/saldos', true)
      .subscribe(response => {
        this.saldo = response.json();
      }, erro => {
      });

    if (this.cartaoService.cartao.produto.bandeira) {
      this.http.pathRest().get('cartao/saldo/moeda/', true)
        .subscribe(response => {
          this.saldo = response.json();
        }, erro => {
          if (erro.status == 401) {

          }
        });
    }
  }

  public saldoAtualizado() {
    if (this.saldo.saldoPontosDevedor < 0) {
      return this.saldo.saldoPontos + this.saldo.saldoPontosDevedor;
    } else {
      return this.saldo.saldoPontos;
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/resources/services/saldo.service.ts